import { FC } from 'react';
import styled from 'styled-components';

import { AssetCategory as AssetDtoCategory } from '@/shared/lib/sj-orm/models/asset.dto';

import { useI18nValues } from '../../hooks';
import { AssetCategoryIcon } from '../AssetCategoryIcon';

type AssetCategoryProps = {
  category: AssetDtoCategory;
  icon?: boolean;
  name?: boolean;
};

export const AssetCategory: FC<AssetCategoryProps> = ({ category, name, icon }) => {
  const values = useI18nValues();

  const showIcon = (!icon && !name) || icon;
  const showName = (!icon && !name) || name;

  return (
    <Container>
      {showIcon && <AssetCategoryIcon category={category} />}
      {showName && <span>{values.category(category)}</span>}
    </Container>
  );
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
